import { useEffect } from 'react';

import { PRIMARY_HTML_ELEMENT_ID } from '../../config/constants';
import { ONBOARDING_CONFIG } from '../../features/onboarding/constants';
import { useStores } from '../../stores/useStores';
import { scrollTo } from '../../utils/scrollTo';

export const useHomeResetScroll = () => {
  const { uiStore, onboardingStore, coinBackStore, loyaltyProgramStore, portalStore } = useStores();

  const { isDialogOpen } = uiStore;
  const { isVisible } = portalStore;
  const isOnboardingOn = onboardingStore.step !== ONBOARDING_CONFIG.CLOSED;
  const isCoinBackTutorialOpen = coinBackStore.coinBackTutorial.open;
  const isLoyaltyProgramTutorialOpen = loyaltyProgramStore.isTutorialOpen;

  useEffect(() => {
    scrollTo(PRIMARY_HTML_ELEMENT_ID, 0);
  }, [isDialogOpen, isVisible, isOnboardingOn, isCoinBackTutorialOpen, isLoyaltyProgramTutorialOpen]);
};
